<template>
    <div class="profile_update_alert_popup">
        <div class="profile_update_alert_popup_canter">
            <div class="profile_update_alert_popup_modal">
                <div class="profile_update_alert_popup_body text-center">
                    <h2>Please update either Hospital Or Organization and Bio info in your Profile to continue.</h2>
                    <div class="userinfo_confirm_btn_wrp">
                        <button class="btn btn-danger mr-3" v-on:click="userInfoAlertPopupClosedFun">No</button>
                        <router-link :to="{ name: 'profileUpdate' }" class="btn btn-success">Update
                            Profile</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import { bus } from '@/main';
export default {
    name: 'profile-update-alert-popup',
    components: {
    },
    props: [],
    methods: {
        userInfoAlertPopupClosedFun() {
            document.body.classList.remove('body_right_scroll_remove');
            bus.$emit('profileUpdateAlertPopupBus', false);
        },
    },
}
</script>
<style lang="scss" scoped>
.profile_update_alert_popup {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.92);
    display: table;
    width: 100%;
    height: 100%;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    .profile_update_alert_popup_canter {
        display: table-cell;
        vertical-align: middle;
    }

    .profile_update_alert_popup_modal {
        background: #000;
        max-width: 640px;
        margin: 0 auto;
        border-radius: 5px;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }

    .profile_update_alert_popup_body {
        padding: 15px;

        h2 {
            font-size: 18px;
            font-weight: normal;
            line-height: 1.4;
            color: #d6d6d6;
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color;
            margin-bottom: 20px;
        }

        .btn {
            min-width: 100px;
            padding: 4px 10px;
            border-radius: 2px;
            border: none !important;
            box-shadow: none !important;

            &:hover {
                background: #87cefa !important;
                color: #22292f !important;
            }

            &.btn-success {
                background: rgba(33, 228, 0, 0.5);
            }

            &.btn-danger {
                background: rgba(255, 18, 18, 0.5);
            }
        }
    }
}
</style>